import React from 'react';
import styled from 'styled-components';

import DownloadMediaComponent
  from '@shipae/components-sandbox/component/download-media';
import DownloadMediaComponentTheme
  from '@shipae/components-sandbox/component/download-media/theme';

import {
  DownloadMediaWidget,
} from 'infrastructure/gatsby/types/download-media';
import SmartLink from 'components/smart-link';

const downloadMediaTheme = {
  ...DownloadMediaComponentTheme,
  Main: styled(DownloadMediaComponentTheme.Main)`
    width: auto;
  `,
  Button: {
    ...DownloadMediaComponentTheme.Button,
    Button: styled(DownloadMediaComponentTheme.Button.Button)`
      width: 100%;
      max-width: 32rem;
    `,
  },
};

const DownloadMedia: React.FC<DownloadMediaWidget> = ({
  title,
  linkLabel,
  linkUrl,
}) => (
  <DownloadMediaComponent
    title={title}
    linkLabel={linkLabel}
    linkUrl={linkUrl}
    theme={downloadMediaTheme}
    linkComponent={SmartLink}
  />
);

export default DownloadMedia;
